import AnalyticsIcon from '@mui/icons-material/Analytics';
import Can from "../../common/Can";
import { Navigate } from "react-router";
import { usePermissionContext, useRoleContext } from "../../../contexts/ProviderProvider";
import AnalyticsDashboardV2 from './AnalyticsDashboardV2';

export const Component = () => {
  const { views } = usePermissionContext();
  const { role } = useRoleContext();
  return (
    <Can action={views.VIEW} items={[views.ANALYTICSV2]} els={<Navigate to="/ballpark/" />}>
      <AnalyticsDashboardV2 view={role != 'Compliance Admin' ? "Internal" : "External"} />
    </Can>
  );
}
export const icon = <AnalyticsIcon sx={{ color: "text.primary" }} />;
export const text = "Analytics Dashboard V2";
export const componentName = "Analytics Dashboard V2";
export const path = "analyticsDashV2";
